/*
 * Deferred video loading (2026-09-12).
 *
 * Homepage video embeds (hero slides, bento cards) ship with `data-defer-src`
 * + `preload="none"` + a poster image. This loader swaps the real src in via
 * IntersectionObserver (300px ahead) so video bytes never block first paint
 * or LCP — the two bento videos were ~9.2MB of the ~13.4MB mobile payload.
 *
 * Data-saver: with navigator.connection.saveData or a 2g/slow-2g effective
 * type the video stays poster-only (no bytes fetched at all).
 *
 * No libraries. The loader is idempotent and delegated via attribute
 * selectors, so dynamically re-rendered sections keep working.
 */
(function () {
  const conn = navigator.connection || {};
  if (conn.saveData || conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g') return;

  function load(video) {
    if (video.dataset.deferLoaded) return;
    const src = video.dataset.deferSrc;
    if (!src) return;
    video.dataset.deferLoaded = '1';
    video.src = src;
    video.load();
    // Autoplaying embeds start once buffered; muted+playsinline keeps this
    // autoplay-policy-safe. Non-autoplay videos (UGC clips) are handled by
    // their own controls and are intentionally NOT preloaded here.
    if (video.hasAttribute('autoplay') && video.hasAttribute('muted')) {
      const p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function boot() {
    const videos = document.querySelectorAll('video[data-defer-src]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(load);
      return;
    }
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            load(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      // Clipping ancestors (overflow-hidden slider tracks) are respected, so
      // horizontally off-screen slides do not trigger a fetch.
      { rootMargin: '300px 0px' }
    );
    videos.forEach(function (video) {
      io.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
